<script setup lang="ts">
import router from '@/router'
import { useUserInfoStore } from '@/stores/modules/user'
import { useFullscreen } from '@vueuse/core'
import AppBreadcrumb from './AppBreadcrumb.vue'
import LockDialog from '@/components/dialog/LockDialog.vue'
import { useShowDialogStore } from '@/stores/modules/dialog'
import LockScreen from '@/components/lock/LockScreen.vue'

const props = defineProps<{
  isMobile?: boolean
}>()

const emit = defineEmits<{
  (e: 'toggle-drawer'): void
}>()

const userStore = useUserInfoStore()
const showDialogStore = useShowDialogStore()

// 刷新
const handleRefresh = () => {
  location.reload()
}

// 全屏 isFullscreen - 是否全屏 toggle - 切换
const { isFullscreen, toggle } = useFullscreen()

// 锁屏
const lockScreen = () => {
  showDialogStore.showLockDialog = true
}

// 处理下拉选项 个人中心 注销登录
const handleCommand = (e: any) => {
  switch (e) {
    case 'logout':
      handleLogout()
      break
    case 'changePassword':
      handleChangePassword()
      break
    default:
      break
  }
}

// 退出登录
const handleLogout = () => {
  ElMessageBox.confirm('是否要退出登录？', '退出登录', {
    confirmButtonText: '是',
    cancelButtonText: '否',
    type: 'warning'
  })
    .then(() => {
      const isAdminRoute = router.currentRoute.value.path.startsWith('/admin')
      userStore.logout().finally(() => {
        if (isAdminRoute) {
          router.push('/login')
        } else {
          router.push('/')
        }
      })
    })
    .catch(() => {})
}

// 修改密码
const handleChangePassword = () => {
  console.log('密码修改成功')
}
</script>
<template>
  <div class="app-header-wrapper">
    <div class="app-header">
      <div class="left">
        <!-- 移动端：汉堡按钮 -->
        <el-icon v-if="props.isMobile" class="icon-btn" :size="22" @click="emit('toggle-drawer')">
          <Expand />
        </el-icon>
        <!-- 桌面端：折叠/展开按钮 -->
        <template v-else>
          <el-icon class="icon-btn" :size="20" @click="userStore.switchFolding">
            <Expand v-if="userStore.collapse" />
            <Fold v-else />
          </el-icon>
          <el-icon class="icon-btn" :size="20" @click="handleRefresh"><RefreshRight /></el-icon>
          <AppBreadcrumb />
        </template>
      </div>
      <div class="tool-bar">
        <!-- 全屏按钮（移动端隐藏） -->
        <el-icon v-if="!props.isMobile" @click="toggle" class="icon-btn" :size="20">
          <FullScreen v-if="!isFullscreen" />
          <Aim v-else />
        </el-icon>
        <!-- 锁屏（移动端隐藏） -->
        <el-icon v-if="!props.isMobile" class="icon-btn" :size="20" @click="lockScreen"><Lock /></el-icon>
        <!-- 消息通知 -->
        <el-icon class="icon-btn" :size="20">
          <el-badge :value="2">
            <Bell />
          </el-badge>
        </el-icon>
        <div class="user-info">
          <!-- 头像 -->
          <el-avatar class="mr-1" :size="30" :src="userStore.avatar" />
          <!-- 用户名（移动端隐藏文字） -->
          <el-dropdown class="dropdown" @command="handleCommand">
            <span>
              <el-text v-if="!props.isMobile" class="mx-1"> {{ userStore.user.username }}</el-text>
              <el-icon class="el-icon--right"><arrow-down /></el-icon>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item>个人中心</el-dropdown-item>
                <el-dropdown-item command="changePassword">修改密码</el-dropdown-item>
                <el-dropdown-item command="logout">退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>
    </div>
    <LockDialog />
    <LockScreen />
  </div>
</template>
<style scoped lang="scss">
.app-header-wrapper {
  @apply h-full w-full;
}
.app-header {
  @apply h-full flex justify-between items-center;
}
.left {
  @apply flex justify-center items-center space-x-4 mr-4;
}
.tool-bar {
  @apply flex justify-center items-center space-x-4 mx-4;
}
.icon-btn {
  @apply cursor-pointer;
}
.user-info {
  @apply flex justify-center items-center space-x-2 px-2 cursor-pointer;
}
</style>
